import ExternalLink from '@/components/atoms/ExternalLink';
import React from 'react';

/**
 * 「解約画面」の重要事項制御コンポーネント。
 */
const QuitTextMobileData = () => {
  return (
    <div className='m-box-02'>
      <div className='m-text'>
        {/* データ専用契約の解約条件と SIM 返却条件をここでまとめて案内する。 */}
        <ul className='m-list'>
          <li className='m-list__item'>
            サービス開始月に解約された場合、1ヶ月分の月額料金を請求いたします。
          </li>
          <li className='m-list__item'>解約日は解約お申し込み月の末日となります。</li>
          <li className='m-list__item'>
            解約月も1ヶ月の月額料金がかかります（日割は行いません）。
          </li>
          <li className='m-list__item'>解約後に残っているチャージ分の返金はできません。</li>
          <li className='m-list__item'>解約時は、プランを問わず解約金は発生しません。</li>
          <li className='m-list__item'>
            SIMカードは貸与品となります。解約後は、お手数ですがSIMカード返送先住所まで郵送もしくは宅配便にてご返却ください。なお、送料はお客さま負担となります。
          </li>
          <div style={{ marginLeft: '2em' }}>
            <ExternalLink href='https://support.sonynetwork.co.jp/faqsupport/nuromobile/web/knowledge2752.html'>
              SIMカード返送先住所
            </ExternalLink>
          </div>
          <li className='m-list__item'>誤返却物の取り扱いについて</li>
          <div style={{ marginLeft: '2em' }}>
            －当社のSIMをご返却される際には、お客さまの私物(以下、私物品)を誤って送付しないようご注意ください。
          </div>
          <div style={{ marginLeft: '2em' }}>
            －私物品については、当社到着後90日間経過したものは廃棄いたします。
          </div>
          <div style={{ marginLeft: '2em' }}>
            －私物品の紛失、破損等については一切責任を負いかねますので、あらかじめご了承ください。
          </div>
          <div style={{ marginLeft: '2em' }}>
            －私物品の返却に掛かる送料はお客さま負担となります。
          </div>
        </ul>
      </div>
      {/* 注意事項と規約リンクを同じ塊に置き、確認から同意までの流れを切らさない。 */}
      <div>解約お申し込みは下記規約類を必ずお読みになったうえで、お手続きください。</div>
      <br />
      <div>NUROモバイルに関する規約</div>
      <br />
      <div className='m-text'>
        <ul className='m-list'>
          <li className='m-list__item'>
            <ExternalLink href='https://mobile.nuro.jp/legal/postpaid/kiyaku.pdf'>
              ご利用規約
            </ExternalLink>
          </li>
        </ul>
      </div>
      <br />
      <div>ご確認いただけましたら、チェックボックスにチェックを入れていただいた上で、</div>
      <div>「月末解約」をご選択ください。</div>

      <br />
      <div>※このページでは解約のお手続きは完了いたしません。</div>
    </div>
  );
};

export default QuitTextMobileData;
